import * as Ruleset from '../methods/set.js';
export const OptionalArray = (fn, value) => value == null ? null : ValidatedArray(fn, value);
export const ValidatedArray = (fn, value) => Array.from(value || [])
    .filter((val) => val != null)
    .map(fn)
    .filter((value) => {
    return typeof fn.isValid == 'function' ? fn.isValid(value) : true;
});
export const FixElementRuleIds = (type, ids, styles) => {
    if (ids == null)
        ids = [];
    const blankId = Ruleset.findBlankId(styles, type);
    const styleIdsOfType = Ruleset.filterByType(styles, type).map((s) => s.details.id);
    const filtered = ids.filter((id) => styleIdsOfType.includes(id));
    if (filtered.length)
        return filtered;
    if (ids.length && !filtered.length)
        return [blankId];
    // if (blankId) return [blankId]
    return [];
};
//# sourceMappingURL=array.js.map